import React, { useState } from 'react';
import { BOM } from '../models/bom';
import { ModalMetadata } from '../models/modal-metadata';
import { ModalMessageType } from '../models/enums';
import GlobalDialog from './Modal/GlobalDialog';


import DataGrid, {
    Column,
    Selection,
    Scrolling,
    LoadPanel
} from 'devextreme-react/data-grid';

import {
    TextBox,
    NumberBox
} from 'devextreme-react';

import { Button } from 'devextreme-react/button';
import { CrudFunctions } from '../utilities/crud-functions';

let key = 0;

const decimalFormat = {
    type: "fixedPoint",
    precision: 4
}

export default function CalculationsForm() {

    const [bom, setBom] =
        useState<BOM>();

    const [globalDialogMetadata, setGlobalDialogMetadata] =
        useState<ModalMetadata>();

    const [globalDialogVisible, setGlobalDialogVisible] =
        useState<boolean>()


    const parts = window.location.href.split('/');
    const batchId = parts[parts.length - 1];

    key++;

    /*
    state: State;

    constructor(props: Props) {
        super(props);

        this.batchNameChanged = this.batchNameChanged.bind(this);
        this.workingDilutionChanged = this.workingDilutionChanged.bind(this);
        this.ampulesNeededChanged = this.ampulesNeededChanged.bind(this);
        this.totalBatchWeightChanged = this.totalBatchWeightChanged.bind(this);
        this.specificGravityChanged = this.specificGravityChanged.bind(this);
        this.weight25mLVolumetricFlaskChanged = this.weight25mLVolumetricFlaskChanged.bind(this);
        this.productionVolumePlus20PercentMLChanged = this.productionVolumePlus20PercentMLChanged.bind(this);
        this.weight25mLFlaskPlusSolutionChanged = this.weight25mLFlaskPlusSolutionChanged.bind(this);
        this.calculateBom = this.calculateBom.bind(this);
        this.runCalculation = this.runCalculation.bind(this);

        const parts = window.location.href.split('/');
        const bid = parts[parts.length - 1];

        this.state = {
            batchId: bid
        };
    }

    render() {
        */

        return (
            <div>
                <div className="title2">Calculations </div>

                <div className="form-row">
                        <Button id="calculateBomButton"
                            text="Calculate BOM" icon="formula" type="success" onClick={calculateBom} />
                </div>

                <div className="form-container">
                    <div id="mainPanel" className="form-section">

                        <div className="grid-form-container">
                            <div className="form-unit">
                                <label className="textbox-label">Batch Name</label>
                                <TextBox id="txtBatchName" className="textbox"
                                    onValueChanged={batchNameChanged}
                                    placeholder="batch name" value={bom ? bom.batchName : ''} />
                            </div>

                            <div className="form-unit">
                                <label className="textbox-label">Working Dilution</label>
                                <NumberBox id="txtWorkingDilution" className="textbox"
                                    onValueChanged={workingDilutionChanged}
                                    showClearButton={true}
                                    placeholder="working dilution" value={bom ? bom.workingDilution : undefined} />
                            </div>
                        </div>
                        <div className="grid-form-container">
                            <div className="form-unit">
                                <label className="textbox-label">Ampules Needed</label>
                                <NumberBox id="txtAmpulesNeeded" className="textbox"
                                    onValueChanged={ampulesNeededChanged}
                                    showClearButton={true}
                                    placeholder="ampules needed" value={bom ? bom.ampulesNeeded : undefined} />
                            </div>

                            <div className="form-unit">
                                <label className="textbox-label">Total Batch Weight</label>
                                <NumberBox id="txtTotalBatchWeight" className="textbox"
                                    onValueChanged={totalBatchWeightChanged}
                                    showClearButton={true}
                                    placeholder="total batch weight" value={bom ? bom.totalBatchWeight : undefined} />
                            </div>
                        </div>

                        <div className="grid-form-container">
                            <div className="form-unit">
                                <label className="textbox-label">Specific Gravity</label>
                                <NumberBox id="txtSpecificGravity" className="textbox"
                                    onValueChanged={specificGravityChanged}
                                    showClearButton={true}
                                    placeholder="specific gravity" value={bom ? bom.specificGravity : undefined} />
                            </div>

                            <div className="form-unit">
                                <label className="textbox-label">Weight of 25mL Volumetric Flask</label>
                                <NumberBox id="txtWeight25mLVolumetricFlask" className="textbox"
                                    onValueChanged={weight25mLVolumetricFlaskChanged}
                                    placeholder="weight 25mL volumetric flask"
                                    value={bom ? bom.weight25mLVolumetricFlask : 0} />
                            </div>
                        </div>

                        <div className="grid-form-container">
                            <div className="form-unit">
                                <label className="textbox-label">Production Volume + 20% (mL)</label>
                                <NumberBox id="txtProductionVolumePlus20PercentML" className="textbox"
                                    onValueChanged={productionVolumePlus20PercentMLChanged}
                                    placeholder="production volume + 20% (mL)"
                                    value={bom ? bom.productionVolumePlus20PercentML : 0} />
                            </div>

                            <div className="form-unit">
                                <label className="textbox-label">Weight of 25mL Flask + Solution</label>
                                <NumberBox id="txtWeight25mLFlaskPlusSolution" className="textbox"
                                    onValueChanged={weight25mLFlaskPlusSolutionChanged}
                                    placeholder="weight 25mL flask + solution"
                                    value={bom ? bom.weight25mLFlaskPlusSolution : 0} />
                            </div>
                        </div>
                        <div className="grid-form-container">
                            <div className="form-unit">
                                <label className="textbox-label">Production Volume + 20% (g)</label>
                                <NumberBox id="txtProductionVolumePlus20PercentG" className="textbox"
                                    onValueChanged={productionVolumePlus20PercentGChanged}
                                    placeholder="specific gravity"
                                    value={bom ? bom.productionVolumePlus20PercentG : 0} />
                            </div>

                            <div className="form-unit">
                                <label className="textbox-label">Solution Density</label>
                                <NumberBox id="txtSolutionDensity" className="textbox"
                                    onValueChanged={solutionDensityChanged}
                                    placeholder="solution density"
                                    value={bom ? bom.solutionDensity : 0} />
                            </div>
                        </div>

                        <div className="title2">Raw Materials</div>

                        <div id="rawMaterialsPanel">
                            <DataGrid
                                height={'20em'}
                                width={'100em'}
                                dataSource={bom && bom.rawMaterials ? bom.rawMaterials : []}
                                showBorders={true}>

                                <LoadPanel enabled={true} />
                                <Selection mode={'single'} />
                                <Scrolling columnRenderingMode="virtual" />

                                <Column dataField={'rawMaterialName'} width={'10em'} />
                                <Column dataField={'compound'} width={'10em'} />
                                <Column dataField={'labTrackingCode'} width={'10em'} />
                                <Column dataField={'nelacRangeFrom'} dataType="number" width={'10em'} />
                                <Column dataField={'nelacRangeTo'} dataType="number" width={'10em'} />
                                <Column dataField={'targetConcentrationMgL'} dataType="number" format={decimalFormat} width={'10em'} />
                                <Column dataField={'targetConcentrationMgMl'} dataType="number" format={decimalFormat} width={'10em'} />
                                <Column dataField={'stockConcentration'} dataType="number" format={decimalFormat} width={'10em'} />
                                <Column dataField={'percentAnalyte'} dataType="number" width={'10em'} />
                                <Column dataField={'purity'} dataType="number" format={decimalFormat} width={'10em'} />
                                <Column dataField={'targetWeight'} dataType="number" format={decimalFormat} width={'10em'} />
                                <Column dataField={'actualWeight'} dataType="number" format={decimalFormat} width={'10em'} />
                                <Column dataField={'actualConcentrationMgMl'} dataType="number" format={decimalFormat} width={'10em'} />
                                <Column dataField={'actualConcentrationMgL'} dataType="number" format={decimalFormat} width={'10em'} />
                            </DataGrid>
                        </div>
                    </div>
                </div>

                {globalDialogVisible &&
                    <GlobalDialog metadata={globalDialogMetadata} />
                }

            </div >
        );
            
    function batchNameChanged(e: any) {
        setBom({...bom, batchName: e.value} );
    }    

    function workingDilutionChanged(e: any) {
        setBom({...bom, workingDilution: e.value });
    }

    function ampulesNeededChanged(e: any) {
        setBom({...bom, ampulesNeeded: e.value });
    }

    function specificGravityChanged(e: any) {
        setBom({...bom, specificGravity: e.value });
    }

    function totalBatchWeightChanged(e: any) {
        setBom({ ...bom, totalBatchWeight: e.value });
    }

    function weight25mLVolumetricFlaskChanged(e: any) {
        setBom({ ...bom, weight25mLVolumetricFlask: e.value });
    }

    function productionVolumePlus20PercentMLChanged(e: any) {
        setBom({ ...bom, productionVolumePlus20PercentML: e.value });
    }

    function weight25mLFlaskPlusSolutionChanged(e: any) {
        setBom({ ...bom, weight25mLFlaskPlusSolution: e.value });
    }

    function productionVolumePlus20PercentGChanged(e: any) {
        setBom({ ...bom, productionVolumePlus20PercentG: e.value });
    }

    function solutionDensityChanged(e: any) {
        setBom({ ...bom, solutionDensity: e.value });
    }

    function calculateBom() {
        if (!bom)
            return;
    }

    async function runCalculation() {
        await CrudFunctions.postData("calculations/bom", bom)
            .then((data) => {

            })
            .then((res) => {

            });
    }
}


